'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z' });

var Equalizer = function Equalizer(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Equalizer = (0, _pure2.default)(Equalizer);
Equalizer.muiName = 'SvgIcon';

exports.default = Equalizer;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Equalizer.js
// module id = 2347
// module chunks = 0